class HeaderSearch {
  constructor() {
    this.header = document.querySelectorAll('.header-search');

    if (this.header.length) {
      this.init();
    }
  }

  init() {
    this.header.forEach(block => {
      const icon = block.querySelector('.header-search__icon');
      if (icon) {
        icon.addEventListener('click', () => {
          const form = block.querySelector('.header-search__form');

          if (form.classList.contains('header-search__form--show')) {
            form.classList.remove('header-search__form--show');
          } else {
            form.classList.add('header-search__form--show');

            form.querySelector('input').focus();
          }
        });
      }
    });
  }
}

export default HeaderSearch;
